import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { Spinner } from '../ui/spinner';

export const PdfViewerLoadingState = () => {
  useLocale();

  return (
    <div className="flex h-[80vh] max-h-[60rem] w-full flex-col items-center justify-center overflow-hidden opacity-50">
      <Spinner />
    </div>
  );
};

export const PdfViewerErrorState = () => {
  useLocale();

  return (
    <div className="flex h-[80vh] max-h-[60rem] flex-col items-center justify-center bg-white/50 dark:bg-background">
      <div className="text-center text-muted-foreground">
        <p>{t('ui.somethingWentWrongWhileLoadingTheDocument')}</p>
        <p className="mt-1 text-sm">{t('ui.pleaseTryAgainOrContactOurSupport')}</p>
      </div>
    </div>
  );
};
